import React from 'react';
import PropTypes from 'prop-types';
import ApplyBranding from 'layout/ApplyBranding';
import Footer from 'layout/Footer';
import { Button } from 'ui';
import { DEFAULT_BRAND_COLORS, DEFAULT_BRAND_STYLES } from 'utils/constants';
import MedallionLogo from 'images/Medallion_Logo_TM_RGB.svg';
import RestrictedIllustration from 'assets/images/restricted_domain.svg';
import navbarStyles from 'layout/Navbar/Navbar.module.css';
import pageStyles from '../SessionExpired/SessionExpired.module.css';
import styles from './RestrictedDomain.module.css';

// Shown instead of the whole app when a non-prod build is opened on authenticating.com.
// It renders outside the Redux store and router, so it must not use Navbar or anything
// else that needs those providers. Same look as the Expired / Invalid Link page.
const RestrictedDomain = ({ allowedHost }) => {
    const { pathname, search, hash } = globalThis.location;
    const allowedUrl = `https://${allowedHost}${pathname}${search}${hash}`;

    return (
        <>
            <ApplyBranding colors={DEFAULT_BRAND_COLORS} {...DEFAULT_BRAND_STYLES} />
            <header className={navbarStyles.navbar}>
                <img
                    src={MedallionLogo}
                    className={navbarStyles.img}
                    alt="Medallion"
                    style={{ maxHeight: '30px' }}
                />
            </header>
            <main className={pageStyles.container}>
                <div className={pageStyles.subContainer}>
                    <h1 className={pageStyles.heading}>Restricted Domain</h1>
                    <img src={RestrictedIllustration} alt="" className={pageStyles.illustration} />
                    <p className={pageStyles.desc}>
                        This domain is not allowed. Please use{' '}
                        <strong className={styles.host}>{allowedHost}</strong> to continue.
                    </p>
                    <div className={styles.actions}>
                        <Button block variant="primary" href={allowedUrl}>
                            Continue
                        </Button>
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
};

RestrictedDomain.propTypes = {
    allowedHost: PropTypes.string.isRequired,
};

export default RestrictedDomain;
